// extracted by mini-css-extract-plugin
export default {"container":"QuestionExample_container__LO2Pd","text":"QuestionExample_text__SXpdt","example":"QuestionExample_example__z4WJ1"};